var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EditForm',{ref:"editForm",attrs:{"disabled":_vm.disabled,"opt-type":_vm.pageType,"amzFlipOrderCode":_vm.amzFlipOrderCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }